import { useQuery } from '@tanstack/react-query';

export function useContentRegisterFileGenerationProcessQuery({
  fileGenerationProcessId,
}) {
  return useQuery({
    enabled: !!fileGenerationProcessId,
    queryKey: [
      'contentRegister',
      'fileGenerationProcesses',
      fileGenerationProcessId,
    ],
    queryFn: async () => {
      const response = await axios.get(
        `/content_register/file_generation_processes/${fileGenerationProcessId}`,
      );
      return response.data;
    },
    refetchInterval: (data) =>
      !data || ['completed', 'failed'].includes(data.data?.attributes?.status) ?
        false
      : 1000,
    refetchIntervalInBackground: true,
    retry: false,
  });
}
